module.exports = __webpack_public_path__ + "static/img/discover-games.016dd6c.png";


//////////////////
// WEBPACK FOOTER
// ./LandingPageTemp/Assets/discover-games.png
// module id = rUGh
// module chunks = 1